module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-voxi-01@2x.95190b3e.jpg";